import axios from 'axios';

export default {
  namespaced: true,
  state: {
    jsonData: '',
  },
  getters: {
    jsonData(state) {
      return state.jsonData;
    },
  },
  mutations: {
    setJsonData(state, jsonData) {
      state.jsonData = jsonData;
      return state;
    },
  },
  actions: {
    fetchJson({ state, commit }) {
      return new Promise((resolve, reject) => {
        if (state.jsonData) {
          resolve(state.jsonData);
        } else {
          const json = process.env.VUE_APP_ENV === 'qa' ? 'onsales-qa.json' : 'onsales.json';
          axios.get(`https://oss.roewe.com.cn/saicmall/json/${json}?timestamp=${new Date().getTime()}`).then((res) => {
            const data = res.data;
            commit('setJsonData', data);
            resolve(data);
          }).catch((e) => reject(e));
        }
      });
    },
  },
};
